<template>
    <div class="sidebar-content-inner">
        <slot />
    </div>
</template>

<style lang="scss">
.sidebar-content-inner {
    position: relative;

    @include sidebar-content;
}
</style>
